// import React, { Fragment } from "react"

export default {
  default: {
    heading: "What happened next was a little unexpected."
  }
}
